import { Text } from "../customComponents";

const Info = ({ messages = [], align = "left", indent=false, italic=false }) => {    
    return <div align={align} style={{marginBottom: 16, marginLeft: indent ? 24 : 0, fontStyle: italic ? 'italic' : 'normal'}}> {messages.map((message) => <Text className='info-text'> {message} </Text>) } </div>
};

export default Info